import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import ProductHot from '@/components/ProductHot'
import commonMixin from '@/mixin/common'
import {getGoodsDetail, getGoodsList} from '@/api/server/goods'
import {cartAdd} from '@/api/server/cart'
export default {
  name: 'DetailPage',
  mixins: [commonMixin],
  data () {
    return {
      _id: null,
      info: {},
      num: 1,
      hots: [],//computed
    }
  },
  computed: {
    skuHead() {
      let skuHead = []
      let skuName = new Set()
      if (this.info && this.info.skus) {
        let skus = this.info.skus
        skus.forEach(item => {
          if (item.skus && item.skus.length > 0) {
            item.skus.forEach(skuItem => {
              if (skuItem.image) {
                if (!skuName.has(skuItem.name)) {
                  skuName.add(skuItem.name)
                  skuHead.push(skuItem)
                }
              }
            })
          }
        })
      }
      return skuHead
    },
    skuList () {
      if (!this.info || !this.info.skus) {
        return []
      }
      let skus = this.info.skus
      let newList = []
      skus.forEach(skusItem => {
        let tmpItem = {
          "id": skusItem.id,
          "counter_price": skusItem.counter_price,
          "retail_price": skusItem.retail_price,
          "stock": skusItem.stock,
          "is_on_sale": skusItem.is_on_sale
        }
        if (skusItem.skus && skusItem.skus.length > 0) {
          skusItem.skus.forEach(item => {
            // sku信息是否有图片
            if ( item.image && item.image.length > 0 ) {
              tmpItem.name = item.name
              tmpItem.head = item
            } else {
              tmpItem.value = item.name
            }
          })
        }
        newList.push(tmpItem)
      })
      return newList
    },
    skuTable() {
      if (!this.skuHead || this.skuHead.length === 0) {
        return []
      }
      if (!this.skuList || !this.skuList.length === 0) {
        return []
      }
      let skuHead = this.skuHead
      let skuList = this.skuList
      let skuNewList = []
      skuHead.forEach(skuHeadItem => {
        let tempItem = { head: skuHeadItem }
        let skuTempList = skuList.filter(skusItem => {
          return skusItem.name === skuHeadItem.name
        })
        tempItem.list = skuTempList
        skuNewList.push(tempItem)
      })
      console.log(skuNewList)
      return skuNewList
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    'product-hot': ProductHot
  },
  methods: {
    addCart () {
      let num = this.num
      let id = this._id
      if (!id || !num) {
        this.warning('库存不足')
        return false
      }
      cartAdd(id, num).then( (res) => {
        if (res.code === 200) {
          this.success('加入购物车成功')
        } else {
          this.error(res.message)
        }
      })

    },
    onCart () {
      let num = this.num
      let id = this._id
      if (!id || !num) {
        this.warning('库存不足')
        return false
      }
      cartAdd(id, num).then( (res) => {
        if (res.code === 200) {
          this.$router.push({name: 'order'})
        } else {
          this.error(res.message)
        }
      })

    },
    numberChange (num) {
      let stock = this.info.stock_count
      if (num > stock) {
        this.warning('库存不足')
      } else {
        this.num = num
      }
    },
    _getHot () {
      let query = {
        tag: 100007
      }
      getGoodsList(query).then((data) => {
        if (data.code === 200 && data.data) {
          this.hots = data.data.data
        } else {
            this.warning(data.message)
        }
      }).catch((e) => {
        console.log('err', e)
      })
    },
    _getDetail () {
        let query = {
            id: this._id
        }
        getGoodsDetail(query).then((data) => {
            if (data.code === 200 && data.data) {
              this.info = data.data
            } else {
                this.warning(data.message)
            }
          }).catch((e) => {
            console.log('err', e)
          })
    },
    reset () {
      this.info = []
      this._getDetail()
      //this._getHot()
    },
    handleRoute (route) {
      if (route.name === 'detail') {
        let id = this.$route.query.id
        if (!id) {
            this.warning('商品不存在')
            this.$route.push({nam: 'login'})
        } else {
            this._id = id
        }
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}